<template>
  <div class="accountability-program">
    <div class="container">
      <div class="accountability-program-content">
        <div class="accountability-program-icon">
          <span class="icon-calendar-full" aria-hidden="true"></span>
        </div>
        <h2>Accountability 12 Week Program</h2>
        <ul class="list-unstyled">
          <li>Personal Training 2x Week</li>
          <li>Nutrition &amp; Meal Planning</li>
          <li>Unlimited Beach-Built Classes</li>
          <li>Daily food monitoring</li>
        </ul>
      </div>
      <!-- <img class="img-battle-ropes" src="../assets/img/chad-battle-ropes.png" alt="" aria-hidden="true" /> -->
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.accountability-program {
  color: $white;
  position: relative;
  // padding: 4rem 0 270px 0;
  padding: 4rem 0;
  text-align: center;
  background: $bb-gray-dark;
  @include gradient-directional($bb-gray-dark, lighten($bb-gray-dark, 4%), 150deg);

  h1, h2, h3, h4, h5, h6,
  .h1, .h2, .h3, .h4, .h5, .h6 {
    color: $white;
  }

  .accountability-program-icon {
    border-radius: 50%;
    display: inline-block;
    line-height: .8;
    text-align: center;
    padding: 1.5rem;
    margin: 0 0 rem(20) 0;
    border: 2px solid $white;

    [class*=icon-] {
      font-size: rem(40);
      // color: $bb-gray-dark;
    }
  }

  .img-battle-ropes {
    position: absolute;
    bottom: -80px;
    right: 0;
    width: 260px;
  }

  @include media-breakpoint-up(sm) {
    padding: 4rem 0;
  }
}

</style>
